import React from 'react';
import PropTypes from 'prop-types';
import './RateButtonGroup.scss';
import { ALL_HOURS, WEEKEND } from '../../../client_customizations/constants';
import { useIntl } from 'react-intl';

const RateButtonGroup = ({
  id,
  value,
  handler,
  label,
  chargingPatterns,
  isSepMay,
}) => {
  const intl = useIntl();

  const getImgSrc = () => {
    const pattern = chargingPatterns.find((p) => p.id === value);
    return pattern ? pattern.image : null;
  };

  const renderButtons = () => {
    let top = [];
    let bottom = [];

    chargingPatterns.map((pattern, i) => {
      if (pattern.id === ALL_HOURS || (!isSepMay && pattern.id === WEEKEND)) {
        return bottom.push(
          <button
            key={i}
            className={`btn ${value === pattern.id ? 'active' : ''}  large`}
            onClick={(e) => handler(e, pattern.id)}
          >
            <p className="title">
              {intl.formatMessage({
                id: 'modal13',
                defaultMessage: pattern.title,
              })}
            </p>
          </button>
        );
      }

      return top.push(
        <div>
          <button
            key={i}
            className={`btn ${value === pattern.id ? 'active' : ''}`}
            onClick={(e) => handler(e, pattern.id)}
          >
            <p className="title">{pattern.title}</p>
          </button>
        </div>
      );
    });

    return (
      <div className="d-flex flex-column">
        <div
          className="mb-3"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${top.length}, 1fr)`,
            gap: '16px',
          }}
        >
          {top}
        </div>
        <div className="d-flex flex-row" style={{ gap: '16px' }}>
          {bottom}
        </div>
      </div>
    );
  };

  return (
    <div className="form-group RateButtonGroup" id={id}>
      <span className="label-style">{label}</span>
      {renderButtons()}

      <img
        src={getImgSrc()}
        style={{ marginTop: '24px' }}
        alt="Hour time line"
      />
    </div>
  );
};

export default RateButtonGroup;

RateButtonGroup.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  handler: PropTypes.func,
  optionNames: PropTypes.array,
  optionValues: PropTypes.array,
  label: PropTypes.string,
};
